// assets/pet-scroller.js
// Setas de navegação para trilhos com scroll-snap (.pet-scroller__track).

class PetScroller extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    if (!this.track) return;
    for (const arrow of this.querySelectorAll('[data-dir]')) {
      arrow.addEventListener('click', () => {
        const card = this.track.firstElementChild;
        const step = card ? card.getBoundingClientRect().width + 16 : this.track.clientWidth;
        this.track.scrollBy({ left: step * Number(arrow.dataset.dir), behavior: 'smooth' });
      });
    }
    this.medir = () => this.toggleAttribute('data-sem-rolagem', this.track.scrollWidth <= this.track.clientWidth + 1);
    this.observador = new ResizeObserver(this.medir);
    this.observador.observe(this.track);
    this.medir();
  }

  disconnectedCallback() {
    this.observador?.disconnect();
  }
}

if (!customElements.get('pet-scroller')) customElements.define('pet-scroller', PetScroller);
